import { cn } from '@/lib/utils';
import { ACTIVE_STATUS_CLASS } from '@/styles/statusColors';

interface PcmpProjectStatusBadgeProps {
  isActive: boolean;
}

export function PcmpProjectStatusBadge({ isActive }: PcmpProjectStatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        isActive ? ACTIVE_STATUS_CLASS.active : ACTIVE_STATUS_CLASS.inactive,
      )}
    >
      {isActive ? 'Active' : 'Inactive'}
    </span>
  );
}
